module.exports = __webpack_public_path__ + "img/backToTop.0a88499.png";